// src/pages/ClaimBonus.jsx
import React, { useState } from "react";
import { Button, Card, Typography, message } from "antd";
import { GiftOutlined, LeftOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

const { Title, Text, Paragraph } = Typography;

const ClaimBonus = ({ onBack, userDetails, onClaimBonus }) => {
  const [claimed, setClaimed] = useState(userDetails?.welcomeBonusClaimed || false);

  const handleClaim = async () => {
    if (claimed) {
      message.warning("You have already claimed your Welcome Bonus!");
      return;
    }

    try {
      await onClaimBonus(); // 🔥 call backend API via parent
      setClaimed(true);
      message.success("🎉 Bonus Claimed! Welcome to Wallet_Pro 🚀");
    } catch (err) {
      message.error("Something went wrong. Try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f5ff, #e6fffb)",
        padding: 20,
      }}
    >
      {/* Back Arrow */}
      <div style={{ marginBottom: 16 }}>
        <LeftOutlined
          style={{
            fontSize: 20,
            color: "#1890ff",
            cursor: "pointer",
          }}
          onClick={onBack}
        />
      </div>

      {/* Bonus Card */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          style={{ width: "100%", maxWidth: 400 }}
        >
          <Card
            style={{
              borderRadius: 20,
              boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
              textAlign: "center",
              padding: "30px 20px",
              opacity: claimed ? 0.9 : 1,
            }}
          >
            {/* Gift Icon with Animation */}
            <motion.div
              animate={
                claimed
                  ? { scale: [1, 1.05, 1] }
                  : { rotate: [0, -10, 10, 0], scale: [1, 1.1, 1] }
              }
              transition={{ repeat: claimed ? 0 : Infinity, duration: 2 }}
              style={{ marginBottom: 16 }}
            >
              <GiftOutlined style={{ fontSize: 60, color: "#faad14" }} />
            </motion.div>

            <Title level={2} style={{ marginBottom: 8 }}>
              Welcome Bonus 🎁
            </Title>

            {claimed ? (
              <Paragraph style={{ fontSize: 16, color: "#52c41a" }}>
                ✅ You’ve already claimed your <b>Wallet_Pro</b> Welcome Bonus.
                <br />
                Happy Spending 🎉
              </Paragraph>
            ) : (
              <>
                <Text type="secondary" style={{ fontSize: 16 }}>
                  Congratulations! As a new member of <b>Wallet_Pro</b>, you
                  have a one-time welcome bonus waiting for you.
                </Text>

                <div style={{ marginTop: 24 }}>
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClick={handleClaim}
                    style={{ borderRadius: 12 }}
                  >
                    Claim Bonus
                  </Button>
                </div>
              </>
            )}
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default ClaimBonus;
